/**
 * 项目文件夹访问权限（Task 9.6）
 *
 * 后端已无 GET /projects/{id}/permissions。D5：能读到文件夹即可查看；
 * 加条目/删文件夹仅创建者。此处由 creator_id 派生，不另打权限接口。
 */
export interface ProjectFolderAccess {
  can_view: boolean
  can_add_work_item: boolean
  can_delete: boolean
  is_creator: boolean
}

export function deriveProjectFolderAccess(
  project: { creator_id: number } | null,
  userId: number | null,
): ProjectFolderAccess {
  if (!project) {
    return {
      can_view: false,
      can_add_work_item: false,
      can_delete: false,
      is_creator: false,
    }
  }
  const isCreator = userId != null && project.creator_id === userId
  return {
    can_view: true,
    can_add_work_item: isCreator,
    can_delete: isCreator,
    is_creator: isCreator,
  }
}
